import { Box, Text, VStack, Checkbox } from '@chakra-ui/react';
import { Scrollbars } from 'react-custom-scrollbars-2';

import type { APIRemark } from 'types/api.types';
import { getRemarkId, getRemarkLabel, isRemarkDisabled } from '../helpers';
import {
  renderThumb,
  renderTrack,
  renderView,
} from 'components/scrollbar/Scrollbar';

interface RemarksColumnProps {
  remarks: APIRemark[];
  validations: Validation[];
  selectedRemarks: string[];
  selectedValidations: string[];
  onToggle: (id: string) => void;
}

const RemarksColumn = ({
  remarks,
  validations,
  selectedRemarks,
  selectedValidations,
  onToggle,
}: RemarksColumnProps) => {
  return (
    <Box flex="1" w={{ base: '100%', lg: 'auto' }}>
      <Text fontWeight="bold" fontSize="lg" mb={3}>
        Remarks
      </Text>
      <Box h={{ base: '200px', lg: '300px' }}>
        <Scrollbars
          autoHide
          renderTrackVertical={renderTrack}
          renderThumbVertical={renderThumb}
          renderView={renderView}
        >
          <VStack align="stretch" spacing={2} width="100%" pl={2} pb={8}>
            {remarks.length === 0 ? (
              <Text color="gray.500" fontSize="sm">
                No missing remarks
              </Text>
            ) : (
              remarks.map((remark) => {
                const remarkId = getRemarkId(remark);
                const disabled = isRemarkDisabled(remark, selectedValidations);
                return (
                  <Checkbox
                    key={remarkId}
                    isChecked={selectedRemarks.includes(remarkId)}
                    onChange={() => onToggle(remarkId)}
                    isDisabled={disabled}
                  >
                    <Text fontSize="sm" fontWeight="medium">
                      {getRemarkLabel(remark, validations)}
                    </Text>
                    {remark.text && (
                      <Text fontSize="xs" color="gray.600">
                        {remark.text}
                      </Text>
                    )}
                  </Checkbox>
                );
              })
            )}
          </VStack>
        </Scrollbars>
      </Box>
    </Box>
  );
};

export default RemarksColumn;
